import AccomplishmentCard from "views/Builder/components/accomplishments/cards";

import badgeImage from "../assets/backend-guild-badge.png";
import backgroundImage from "../assets/backend-guild-background.png";

export const BackEndGuildCard = () => (
  <AccomplishmentCard
    badgeImage={badgeImage}
    backgroundImage={backgroundImage}
    title="Backend guild member"
    description="A builder with deep backend expertise, from scalable systems to thoughtful trade-offs."
  />
);
